import { useMutation, useQueryClient } from "@tanstack/react-query";
import { documentService } from "@/services/ServiceRegistry";
import { CreateDocumentDto } from "@/types/document";
import { guestKeys } from "@/components/pages/reservations/guests/hooks/useGuests";
import { reservationKeys } from "@/hooks/useReservations";

export const documentKeys = {
  all: ["documents"] as const,
  lists: () => [...documentKeys.all, "list"] as const,
};

export const useCreateDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (documentData: CreateDocumentDto) =>
      documentService.createDocument(documentData),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: documentKeys.lists() });
      queryClient.invalidateQueries({
        queryKey: guestKeys.detail(variables.guestId),
      });
      queryClient.invalidateQueries({
        queryKey: reservationKeys.detail(variables.bookingId),
      });
    },
  });
};
